import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface FormData {
  // Define the structure of each form data item if known
  // For now, using 'any' but recommended to define properly
  [key: string]: any;
}

interface FormConfigState {
  data: FormData[];
  loading: boolean;
  error: string | null;
}

const initialState: FormConfigState = {
  data: [],
  loading: false,
  error: null,
};

// Async thunk
export const fetchFormQuestionsData = createAsyncThunk<FormData[]>(
  'data/fetchData',
  async (_, thunkAPI) => {
    // Simulating an API call
    const response = await new Promise<{ data: FormData[] }>((resolve) => {
      setTimeout(() => {
        resolve({ data: [] });
      }, 1000);
    });
    return response.data; // Return actual data
  }
);

// Create slice
const formConfig = createSlice({
  name: 'formConfig',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFormQuestionsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFormQuestionsData.fulfilled, (state, action: PayloadAction<FormData[]>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchFormQuestionsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Something went wrong';
      });
  },
});

export default formConfig.reducer;
